<template>
  <div class="wrapper">
    <div v-if="list.length === 0"
         class="all-day">{{ placeholders[2] || $t('pages_settings_timerangegroup_944') }}</div>
    <div class="item"
         v-for="(item, index) in list"
         :key="index">
      <TimePicker class="picker"
                  @on-change="(v) => changeStart(index, v)"
                  v-model="item[startKey]"
                  format="HH:mm"
                  :placeholder="placeholders[0] || $t('pages_settings_timerangegroup_945')"></TimePicker>
      <TimePicker class="picker"
                  @on-change="(v) => changeEnd(index, v)"
                  :disabled-hours="getDisabledEndHours(item)"
                  :disabled-minutes="getDisabledEndMinutes(item)"
                  v-model="item[endKey]"
                  format="HH:mm"
                  :placeholder="placeholders[1] || $t('pages_settings_timerangegroup_946')"></TimePicker>
      <Button type="text"
              @click="remove(index)">{{$t('pages_mall_groups_group_item_601')}}</Button>
    </div>
    <div class="add-btn"
         @click="addDuration">{{$t('pages_settings_timerangegroup_947')}}</div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import moment from 'moment'

export default {
  name: 'TimeRangeGroup',
  props: {
    value: Array,
    placeholders: {
      type: Array,
      default: () => []
    },
    startKey: String,
    endKey: String
  },
  data () {
    return {
      list: []
    };
  },
  methods: {
    getDisabledEndHours (item) {
      const start = moment().format(`YYYY-MM-DD ${item[this.startKey]}:00`);
      const startHour = +moment(start).format('HH');
      const result = [];
      for (let i = startHour - 1; i >= 0; i--) {
        result.push(i);
      }
      return result;
    },
    getDisabledEndMinutes (item) {
      const start = moment().format(`YYYY-MM-DD ${item[this.startKey]}:00`);
      const end = moment().format(`YYYY-MM-DD ${item[this.endKey]}:00`);
      const startHour = +moment(start).format('HH');
      const endHour = +moment(end).format('HH');
      if (endHour - startHour > 0) return [];
      const startMinute = +moment(start).format('mm');
      const result = [];
      for (let i = startMinute; i >= 0; i--) {
        result.push(i);
      }
      return result;
    },
    changeStart (index, value) {
      this.list[index][this.startKey] = value;
      this.$nextTick(() => {
        this.$emit('input', this.list);
      });
    },
    changeEnd (index, value) {
      console.info('000', this.endKey)
      this.list[index][this.endKey] = value;
      this.$nextTick(() => {
        this.$emit('input', this.list);
      });
    },
    remove (index) {
      const newArr = this.list.slice();
      newArr.splice(index, 1);
      this.list = newArr;
      this.$nextTick(() => {
        this.$emit('input', this.list);
      });
    },
    addDuration () {
      this.list = this.list.concat([{
        [this.startKey]: moment().format('HH:mm'),
        [this.endKey]: moment().format('HH:mm'),
      }])
      this.$nextTick(() => {
        this.$emit('input', this.list);
      });
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        if (Array.isArray(val)) {
          this.list = val;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  background: #f5f5f5;
  max-width: 460px;
  border: 1px solid #d4d4d4;
  padding: 10px;
}
.all-day {
  background: #2d8cf0;
  color: #fff;
  text-align: center;
  line-height: 30px;
  font-size: 12px;
}
.item {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
}
.picker {
  margin-right: 8px;
}
.add-btn {
  display: block;
  background: #ddd;
  text-align: center;
  line-height: 32px;
  height: 32px;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: #ccc;
  }
}
</style>
